import { Box } from "@mui/material";
import Flex from "../../../../../components/Flex";
import StyledDialog from "../../../../../components/StyledDialog";
import StyledButtonV2 from "../../../../../components/app/StyledButtonV2";
import ProfileViewer from "../../../../../components/ProfileViewer";
import { formatAppointmentDateTime } from "../utils/dateFormatters";

interface PatientAppointmentDetails {
  uuid: string;
  appStatusForPatient?: string;
  appointmentTime?: string;
  startTime?: string;
  endTime?: string;
  duration?: number;
  mode?: string;
  locationName?: string | null;
  patientJoinLink?: string;
  patientName?: string;
  providerId?: string;
  providerName?: string;
  providerRole?: string;
  status?: string;
  type?: string;
  chiefComplaint?: string;
}

type Props = {
  open: boolean;
  onClose: () => void;
  appointment?: PatientAppointmentDetails;
  isPast?: boolean;
  onCancel?: (appointmentId: string) => void;
  onJoin?: (patientJoinLink?: string) => void;
};
const getModeLabel = (mode?: string) =>
  mode === "VIRTUAL" || mode === "Telehealth" ? "Telehealth" : "In-person";

const PatientAppointmentDetailsModal: React.FC<Props> = ({
  open,
  onClose,
  appointment,
  isPast,
  onCancel,
  onJoin,
}) => {
  if (!appointment) return null;
  const data = {
    "Provider Name": appointment.providerName ?? "-",
    "Appointment Type": getModeLabel(appointment.mode),
    "Date & Time":
      formatAppointmentDateTime(
        new Date(appointment.appointmentTime ?? ""),
        Number(appointment.duration ?? 0)
      ) ?? "-",
    Location: appointment.locationName ?? "-",
  };
  const canJoin =
    !isPast &&
    appointment.mode === "VIRTUAL" &&
    (appointment.status === "CONFIRMED" ||
      appointment.status === "IN_EXAM" ||
      appointment.status === "CHECKED_IN");

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      dialogTitle="Appointment Details"
      PaperProps={{ sx: { width: "560px", borderRadius: 2 } }}
      dialogAction={
        <Flex gap={1.5} px={2} py={1}>
          {
            <StyledButtonV2
              label="Cancel"
              variant="outlined"
              onClick={() => onCancel?.(appointment.uuid)}
              sx={{ color: "#1A1A1A", borderColor: "#E0E0E0" }}
            />
          }
          {canJoin && (
            <StyledButtonV2
              label="Join"
              variant="contained"
              onClick={() => onJoin?.(appointment.patientJoinLink)}
            />
          )}
        </Flex>
      }
    >
      <Box px={1} py={1} minWidth={"500px"}>
        <ProfileViewer data={data} firstColW={4} secondColW={8} />
      </Box>
    </StyledDialog>
  );
};

export default PatientAppointmentDetailsModal;
